import { AxiosInstance } from "axios";
import { useQuery } from "react-query";

import { RiskTemplate } from "types";
import { useClient } from "utils/client";

const fetchRiskTemplate = async (client: AxiosInstance, crn: string) => {
  const { data } = await client.get(`/risk-templates/${crn}`);
  return data as RiskTemplate;
};

export const useRiskTemplate = (crn: string) => {
  const client = useClient();

  const { data: riskTemplate, isLoading } = useQuery(
    ["riskTemplate", crn],
    () => fetchRiskTemplate(client, crn),
    {
      enabled: !!crn,
    }
  );

  return {
    riskTemplate,
    isLoading,
  };
};
